export default {
      id: "clear-usage",
      viewBox: "0 0 14 14",
      url: __webpack_public_path__ + "sprite.1790164512331.svg#clear-usage",
      toString: function () {
        return this.url;
      }
    }